/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Automate_Daily_WorkInputs */



/**
* | output |
* | --- |
* | "Automate repetitive daily work" |
*
* @param {Onboarding_Usage_Automate_Daily_WorkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_automate_daily_work = /** @type {((inputs?: Onboarding_Usage_Automate_Daily_WorkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Automate_Daily_WorkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wiederkehrende tägliche Arbeit automatisieren")
	return /** @type {LocalizedString} */ ("Automate repetitive daily work")
});